export function isMobileDevice(): boolean {
  if (typeof navigator !== 'undefined') {
    const mobile = navigator.userAgentData?.mobile;
    if (typeof mobile === 'boolean') return mobile;

    if (/Mobi|Android|iPhone|iPod/i.test(navigator.userAgent)) return true;
  }
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    return window.matchMedia('(pointer: coarse)').matches;
  }
  return false;
}
